<div class="container schedule-catalog">
  <page-title [title]="title"></page-title>
  <p class="catalog-intro">Encontre o procedimento, profissional ou clínica para iniciar o agendamento.</p>

  <div class="row busca">
    <div class="col-xs-12">
      <div class="search-container">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Busque por procedimento, especialista ou clínica</mat-label>
          <input
            type="text"
            matInput
            [formControl]="searchControl"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
            (keydown)="onInputKeydown($event)"
            placeholder="Ex.: ecocardiograma, cardiologista ou clínica"
            autocomplete="off"
            role="combobox"
            aria-autocomplete="list"
            aria-controls="schedule-search-suggestions"
            [attr.aria-expanded]="showAutocompletePanel"
            [attr.aria-activedescendant]="activeSuggestionId"
            [attr.aria-describedby]="showAutocompleteHint ? 'schedule-search-hint' : null"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-card *ngIf="showAutocompletePanel" id="schedule-search-suggestions" class="autocomplete-panel" role="listbox" aria-label="Sugestões de busca">
          <section *ngFor="let group of autocompleteSuggestionGroups" class="suggestion-group" role="group" [attr.aria-label]="group.category">
            <div class="suggestion-category">{{ group.category }}</div>
            <button
              type="button"
              *ngFor="let suggestion of group.suggestions"
              class="suggestion-item"
              role="option"
              [id]="getSuggestionId(suggestion)"
              [class.active]="isSuggestionActive(suggestion)"
              [attr.aria-selected]="isSuggestionActive(suggestion)"
              (mouseenter)="activateSuggestion(suggestion)"
              (mousedown)="$event.preventDefault()"
              (click)="selectSuggestion(suggestion)"
            >
              <mat-icon aria-hidden="true">{{ suggestion.mode === 'specialist' ? 'person' : suggestion.mode === 'clinic' ? 'local_hospital' : 'medical_services' }}</mat-icon>
              <span>{{ suggestion.label }}</span>
            </button>
          </section>
          <div *ngIf="visibleAutocompleteSuggestions.length === 0" class="autocomplete-empty" role="status" aria-live="polite">
            {{ loading ? 'Carregando sugestões…' : 'Nenhuma sugestão encontrada. Continue digitando para filtrar o catálogo.' }}
          </div>
        </mat-card>
        <small *ngIf="showAutocompleteHint" id="schedule-search-hint" class="search-hint">Digite ao menos 2 caracteres para ver sugestões.</small>
      </div>
    </div>

    <div class="col-xs-12 col-sm-10 col-md-9 col-lg-11 rangeBar">
      <mat-label>Raio de busca: {{ formatLabel(distance) }}</mat-label>
      <mat-slider
        style="width: 100%"
        thumbLabel
        [displayWith]="formatLabel"
        tickInterval="10000"
        min="1000"
        max="500000"
        [(ngModel)]="distance"
        aria-label="Raio de busca em quilômetros"
      ></mat-slider>
    </div>

    <div class="col-xs-12 col-sm-2 col-md-3 col-lg-1 btBuscarRow">
      <button mat-flat-button color="primary" (click)="getProceduresNearest()" [disabled]="loading">
        <ng-container *ngIf="!loading">Buscar</ng-container>
        <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
      </button>
    </div>

    <div *ngIf="latLong.length === 0" class="col-md-4">
      <button mat-stroked-button color="primary" (click)="getCurrentPosition()" class="text-center btAtivar">
        Ativar localização
      </button>
    </div>
  </div>

  <div class="catalog-mode-row">
    <span class="catalog-mode-label">Buscar por</span>
    <mat-button-toggle-group class="catalog-mode-toggle" [value]="activeSearchMode" aria-label="Escolha como buscar">
      <mat-button-toggle value="procedure" (click)="navigateToMode('procedure')">
        <mat-icon aria-hidden="true">medical_services</mat-icon>
        Procedimento / Exame
      </mat-button-toggle>
      <mat-button-toggle value="specialist" (click)="navigateToMode('specialist')">
        <mat-icon aria-hidden="true">person</mat-icon>
        Especialista
      </mat-button-toggle>
      <mat-button-toggle value="clinic" (click)="navigateToMode('clinic')">
        <mat-icon aria-hidden="true">local_hospital</mat-icon>
        Clínica / Local
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div *ngIf="search.length >= 2 && catalogGroupCount > 0" class="results-count" aria-live="polite">
    {{ catalogGroupCount }} {{ activeSearchMode === 'clinic' ? (catalogGroupCount === 1 ? 'clínica encontrada' : 'clínicas encontradas') : (catalogGroupCount === 1 ? 'procedimento encontrado' : 'procedimentos encontrados') }}
  </div>

  <div *ngIf="loading" class="no-results" aria-live="polite">
    <mat-icon aria-hidden="true">search</mat-icon>
    <p>Buscando opções próximas…</p>
  </div>

  <ng-container *ngIf="!loading && latLong.length > 0">
    <ng-container *ngIf="activeSearchMode === 'procedure'; else clinicCatalog">
      <div class="catalog-cards" *ngIf="paginatedProcedures.length > 0">
        <mat-card *ngFor="let group of paginatedProcedures" class="catalog-card">
          <button
            type="button"
            class="catalog-card-heading"
            (click)="toggleGroup(group.key)"
            [attr.aria-expanded]="expandedGroupKey === group.key"
          >
            <span class="catalog-card-icon"><mat-icon aria-hidden="true">medical_services</mat-icon></span>
            <span class="catalog-card-title">
              <strong>{{ group.name }}</strong>
              <small>{{ group.clinicCount }} {{ group.clinicCount === 1 ? 'unidade realiza este serviço' : 'unidades realizam este serviço' }}</small>
              <small class="procedure-price">{{ getProcedureGroupPriceLabel(group) }}</small>
              <small class="procedure-coverage">{{ getProcedureGroupCoverageLabel(group) }}</small>
            </span>
            <mat-icon class="catalog-expand-icon" aria-hidden="true">
              {{ expandedGroupKey === group.key ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </button>

          <div *ngIf="expandedGroupKey === group.key" class="catalog-options">
            <schedule-service-option
              *ngFor="let procedure of group.services"
              [service]="procedure"
              [locationLabel]="getClinicDisplayName(procedure)"
              [privatePriceLabel]="getProcedurePriceLabel(procedure)"
              [coverageLabel]="getProcedureCoverageLabel(procedure)"
              [providers]="getSpecialistNamesForProcedure(procedure)"
              (schedule)="openEncounterRegistrationForm(procedure)"
            ></schedule-service-option>
          </div>
        </mat-card>
      </div>
    </ng-container>

    <ng-template #clinicCatalog>
      <div class="catalog-cards" *ngIf="paginatedProcedures.length > 0">
        <mat-card *ngFor="let group of paginatedProcedures" class="catalog-card">
          <div class="clinic-card-heading">
            <img [src]="getOrganizationPhoto(group.organizationId)" [alt]="'Logo de ' + group.name" />
            <button
              type="button"
              class="catalog-card-title clinic-card-title"
              (click)="toggleGroup(group.key)"
              [attr.aria-expanded]="expandedGroupKey === group.key"
            >
              <strong>{{ group.name }}</strong>
              <small>{{ group.services.length ? getClinicLocationLabel(group.services[0]) : 'Localização não informada' }}</small>
              <small class="procedure-price">{{ getClinicPriceLabel(group) }}</small>
              <small class="procedure-coverage">{{ getClinicCoverageLabel(group) }}</small>
            </button>
            <button mat-icon-button color="primary" aria-label="Sobre a clínica" (click)="openOrnigazationInfos(group.organizationId)">
              <mat-icon>info_outline</mat-icon>
            </button>
            <button
              type="button"
              class="catalog-expand-button"
              (click)="toggleGroup(group.key)"
              [attr.aria-label]="expandedGroupKey === group.key ? 'Recolher serviços' : 'Ver serviços'"
              [attr.aria-expanded]="expandedGroupKey === group.key"
            >
              <mat-icon aria-hidden="true">{{ expandedGroupKey === group.key ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </div>

          <div *ngIf="expandedGroupKey === group.key" class="catalog-options">
            <schedule-service-option
              *ngFor="let procedure of group.services"
              [service]="procedure"
              [privatePriceLabel]="getProcedurePriceLabel(procedure)"
              [coverageLabel]="getProcedureCoverageLabel(procedure)"
              [providers]="getSpecialistNamesForProcedure(procedure)"
              (schedule)="openEncounterRegistrationForm(procedure)"
            ></schedule-service-option>
          </div>
        </mat-card>
      </div>
    </ng-template>
  </ng-container>

  <div *ngIf="!loading && search.length >= 2 && catalogGroupCount === 0" class="no-results">
    <mat-icon aria-hidden="true">search_off</mat-icon>
    <p>Nenhuma opção encontrada para “{{ search }}”.</p>
  </div>

  <div *ngIf="hasSearched && !loading && procedures.length === 0" class="no-results">
    <mat-icon aria-hidden="true">location_off</mat-icon>
    <p>Nenhum procedimento disponível nessa localização e raio.</p>
  </div>

  <div *ngIf="totalPages > 1" class="pagination-controls">
    <button mat-button color="primary" (click)="currentPage = currentPage - 1" [disabled]="currentPage === 0">Anterior</button>
    <span>Página {{ currentPage + 1 }} de {{ totalPages }}</span>
    <button mat-button color="primary" (click)="currentPage = currentPage + 1" [disabled]="currentPage === totalPages - 1">Próxima</button>
  </div>
</div>
